import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../Utils/axiosInstance";
export const fetchCustomerDetails = createAsyncThunk(
  "customer/fetchCustomerDetails",
  async (payload, { rejectWithValue }) => {
    try {
      const getLoggedInUser = sessionStorage.getItem("loggedInUser");
      if (!getLoggedInUser) return rejectWithValue("User not logged in");
      const data = {
        ...payload,
      };
      //   console.log(data, "cd");
      const res = await axiosInstance.post(
        "/CustomerArea/GetCustomerdetail",
        data,
      );
      const obj = res.data;
      // console.log("customerDetail Res", obj, res);
      if (obj.code === "3") {
        sessionStorage.clear();
        return rejectWithValue("Session expired");
      }
      if (obj.code === "0") {
        return rejectWithValue("Session expired");
      }
      return obj.Response;
    } catch (error) {
      return rejectWithValue(
        error?.message || "Error fetching customer details",
      );
    }
  },
);

const customerSlice = createSlice({
  name: "customer",
  initialState: {
    customerDetails: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearCustomer: (state) => {
      state.customerDetails = null;
      state.error = null;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomerDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCustomerDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.customerDetails = action.payload;
      })
      .addCase(fetchCustomerDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearCustomer } = customerSlice.actions;
export default customerSlice.reducer;
